import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "space-y-8" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "card-global flex divide-x" }
const _hoisted_4 = { class: "flex-1 flex-col space-y-6" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "input-form-label" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_12 = { class: "flex space-x-12" }
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = { class: "grid grid-cols-1 mt-5" }
const _hoisted_15 = { class: "md:text-lg text-lg text-gray-600 text-light" }
const _hoisted_16 = { class: "grid grid-cols-3 mt-3 mx-1" }
const _hoisted_17 = {
  class: "pl-2",
  for: "checkbox-user"
}
const _hoisted_18 = {
  class: "pl-2",
  for: "checkbox-job"
}
const _hoisted_19 = {
  class: "pl-2",
  for: "checkbox-company"
}
const _hoisted_20 = { class: "grid grid-cols-3 mt-3 mx-1" }
const _hoisted_21 = {
  class: "pl-2",
  for: "checkbox-nomenclature"
}
const _hoisted_22 = {
  class: "pl-2",
  for: "checkbox-template"
}
const _hoisted_23 = {
  class: "pl-2",
  for: "checkbox-constructor"
}
const _hoisted_24 = { class: "grid grid-cols-3 mt-3 mx-1" }
const _hoisted_25 = {
  class: "pl-2",
  for: "checkbox-role"
}
const _hoisted_26 = {
  class: "pl-2",
  for: "checkbox-template-document"
}
const _hoisted_27 = {
  class: "pl-2",
  for: "checkbox-logs"
}
const _hoisted_28 = { class: "grid grid-cols-1 mt-5" }
const _hoisted_29 = { class: "md:text-lg text-lg text-gray-600 text-light" }
const _hoisted_30 = { class: "grid grid-cols-1 mt-3 mx-1" }
const _hoisted_31 = {
  class: "pl-2",
  for: "checkbox-document"
}
const _hoisted_32 = { class: "grid grid-cols-1 mt-5" }
const _hoisted_33 = { class: "md:text-lg text-lg text-gray-600 text-light" }
const _hoisted_34 = { class: "grid grid-cols-1 gap-3 mt-3 mx-1 md:grid-cols-2 md:gap-x-8" }
const _hoisted_35 = { class: "font-semibold text-gray-700" }
const _hoisted_36 = ["value"]

import BackButton from "@/components/common/BackButton.vue";
import { ref, onMounted, reactive, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { SegmentedButtons, Button } from "@/components/common/";
import { Role } from "@/types/";
import { StatusesEnum } from "@/store";
import { useStore } from "vuex";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { RoleActions } from "@/store/modules/role/actions";
import { RoleGetters } from "@/store/modules/role/getters";
import { t } from "@/i18n";
import { getCommonStatusOptions } from "@/utils/labels";
import { getPermissionGroups } from "@/utils/rolePermissions";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();

const state = reactive<Role>({
  name: "",
  adGroup: "",
  status: StatusesEnum.ACTIVE,
  systemConfig: {
    company: false,
    job: false,
    role: false,
    user: false,
    nomenclature: false,
    processTemplate: false,
    documentConstructor: false,
    documentTemplate: false,
    logs: false,
  },
  documents: {
    canRead: false,
  },
  permissions: [],
});

const statuses = computed(() => getCommonStatusOptions());
const permissionGroups = computed(() => getPermissionGroups());

const rules = {
  name: { required },
  status: { required },
  systemConfig: {
    company: {},
    job: {},
    role: {},
    user: {},
    nomenclature: {},
    processTemplate: {},
    documentConstructor: {},
    documentTemplate: {},
    logs: {},
  },
  documents: {
    canRead: {},
  },
};
const $externalResults = ref({});
const submitted = ref(false);
const v$ = useVuelidate(rules, state, { $externalResults });
const adGroupErrors = computed(
  () => (($externalResults.value as any)?.adGroup as any[]) ?? []
);

async function handleSubmit(isFormValid: boolean) {
  submitted.value = true;
  if (!isFormValid) {
    return;
  }

  route.name === "RoleEdit" ? await updateRole() : await createRole();
}

const createRole = async () => {
  await store
    .dispatch(RoleActions.CREATE, state)
    .then(async () => {
      await router.push({ name: "RoleList" });
    })
    .catch((error) => {
      $externalResults.value = error.data.data;
    });
};

const updateRole = async () => {
  await store
    .dispatch(RoleActions.UPDATE, { id: state.id, data: state })
    .then(async () => {
      await router.push({ name: "RoleList" });
    })
    .catch((error) => {
      $externalResults.value = error.data.data;
    });
};

if (route.name === "RoleEdit") {
  onMounted(async () => {
    await store.dispatch(RoleActions.FETCH_ONE, route.params.id);
    const role = store.getters[RoleGetters.GET_CURRENT];
    state.id = role.id;
    state.name = role.name;
    state.adGroup = role.adGroup ?? "";
    state.status = role.status;
    state.systemConfig = role.systemConfig;
    state.documents = role.documents;
    state.permissions = role.permissions ?? [];
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'RoleList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$route.name === "RoleEdit"
          ? _unref(t)("userForm.titleEdit")
          : _unref(t)("userForm.titleCreate")) + " " + _toDisplayString(_unref(t)("roleForm.role")), 1),
      _createElementVNode("form", {
        onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", {
                class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).name.$invalid && submitted.value }])
              }, _toDisplayString(_unref(t)("common.title")), 3),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
                type: "text",
                class: _normalizeClass(["input-form", { 'p-invalid': _unref(v$).name.$invalid && submitted.value }]),
                placeholder: _unref(t)('common.placeholderName')
              }, null, 10, _hoisted_6), [
                [_vModelText, _unref(v$).name.$model]
              ]),
              (_unref(v$).name.$externalResults.length > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(v$).name.$externalResults[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)("roleForm.adGroup")), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).adGroup) = $event)),
                type: "text",
                class: "input-form",
                placeholder: _unref(t)('roleForm.adGroupPlaceholder')
              }, null, 8, _hoisted_10), [
                [_vModelText, _unref(state).adGroup]
              ]),
              (_unref(adGroupErrors).length > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(adGroupErrors)[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", {
                  class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).status.$invalid && submitted.value }])
                }, _toDisplayString(_unref(t)("common.status")), 3),
                _createVNode(_unref(SegmentedButtons), {
                  modelValue: _unref(v$).status.$model,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).status.$model) = $event)),
                  class: _normalizeClass({ 'p-invalid': _unref(v$).status.$invalid && submitted.value }),
                  options: _unref(statuses),
                  required: ""
                }, null, 8, ["modelValue", "class", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(t)("roleForm.systemConfig")), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "checkbox-user",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).systemConfig.user.$model) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _unref(v$).systemConfig.user.$model]
                  ]),
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(t)("roleForm.user")), 1)
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "checkbox-job",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).systemConfig.job.$model) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _unref(v$).systemConfig.job.$model]
                  ]),
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(t)("common.job")), 1)
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "checkbox-company",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).systemConfig.company.$model) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _unref(v$).systemConfig.company.$model]
                  ]),
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(t)("common.company")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "checkbox-nomenclature",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).systemConfig.nomenclature.$model) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _unref(v$).systemConfig.nomenclature.$model]
                  ]),
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(t)("roleForm.nomenclature")), 1)
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "checkbox-template",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(v$).systemConfig.processTemplate.$model) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _unref(v$).systemConfig.processTemplate.$model]
                  ]),
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(t)("roleForm.processes")), 1)
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "checkbox-constructor",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).systemConfig.documentConstructor.$model) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _unref(v$).systemConfig.documentConstructor.$model]
                  ]),
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(t)("roleForm.constructor")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "checkbox-role",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).systemConfig.role.$model) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _unref(v$).systemConfig.role.$model]
                  ]),
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(t)("common.role")), 1)
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "checkbox-template-document",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).systemConfig.documentTemplate.$model) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _unref(v$).systemConfig.documentTemplate.$model]
                  ]),
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(t)("roleForm.template")), 1)
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "checkbox-logs",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).systemConfig.logs.$model) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _unref(v$).systemConfig.logs.$model]
                  ]),
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(t)("roleForm.viewLogs")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(t)("roleForm.documentConfig")), 1),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "checkbox-document",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).documents.canRead.$model) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _unref(v$).documents.canRead.$model]
                  ]),
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_unref(t)("roleForm.viewDocument")), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(t)("roleForm.permissions")), 1),
              _createElementVNode("div", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(permissionGroups), (group) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: group.key,
                    class: "space-y-3"
                  }, [
                    _createElementVNode("h3", _hoisted_35, _toDisplayString(group.label), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.permissions, (permission) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: permission.value,
                        class: "flex items-start gap-2"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(state).permissions) = $event)),
                          type: "checkbox",
                          value: permission.value,
                          class: "mt-1"
                        }, null, 8, _hoisted_36), [
                          [_vModelCheckbox, _unref(state).permissions]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(permission.label), 1)
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_unref(Button), { type: "submit" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$route.name === "RoleEdit"
                  ? _unref(t)("roleForm.editRole")
                  : _unref(t)("roleForm.createRole")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ], 32)
    ])
  ], 64))
}
}

})